import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2259fd24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "branch-context-display" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Switch Branch", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-grey-6" }, " Select a branch to work with ", -1))

import { ref, onMounted, computed } from 'vue';
import { BranchService, type Branch } from '../../service/branch-service';
import Swal from 'sweetalert2';

// Services

export default /*#__PURE__*/_defineComponent({
  __name: 'BranchContextDisplay',
  setup(__props, { expose: __expose }) {

const branchService = new BranchService();

// Reactive data
const loading = ref(false);
const currentBranch = ref<Branch | null>(null);
const accessibleBranches = ref<Branch[]>([]);
const showBranchSelector = ref(false);

// Computed
const accessibleBranchCount = computed(() => accessibleBranches.value.length);

// Methods
const loadBranchContext = async () => {
  loading.value = true;
  try {
    // Load accessible branches
    accessibleBranches.value = await branchService.getAccessibleBranches();
    
    // Set current branch (for now, use the first one or user's primary branch)
    // In a real implementation, this would come from user context/preferences
    if (accessibleBranches.value.length > 0) {
      currentBranch.value = accessibleBranches.value[0];
    }
  } catch (error) {
    console.error('Failed to load branch context:', error);
    
    // Show error notification
    Swal.fire({
      title: 'Branch Access Error',
      text: 'Failed to load your branch access. Please contact your administrator.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  } finally {
    loading.value = false;
  }
};

const switchToBranch = (branch: Branch) => {
  currentBranch.value = branch;
  showBranchSelector.value = false;
  
  // In a real implementation, you would:
  // 1. Update user preferences/session
  // 2. Emit event to parent components
  // 3. Refresh data that depends on branch context
  
  Swal.fire({
    title: 'Branch Switched',
    text: `Now working with: ${branch.name}`,
    icon: 'success',
    timer: 2000,
    showConfirmButton: false
  });
};

const getBranchIcon = (type?: string) => {
  switch (type) {
    case 'HEAD_OFFICE': return 'corporate_fare';
    case 'REGIONAL': return 'location_city';
    case 'WAREHOUSE': return 'warehouse';
    case 'STORE': return 'store';
    default: return 'business';
  }
};

const getBranchColor = () => {
  if (!currentBranch.value) return 'grey';
  
  switch (currentBranch.value.status) {
    case 'ACTIVE': return 'green';
    case 'INACTIVE': return 'grey';
    case 'SUSPENDED': return 'orange';
    default: return 'grey';
  }
};

const formatBranchDisplay = () => {
  if (!currentBranch.value) return 'No Branch';
  return `${currentBranch.value.name}`;
};

// Lifecycle
onMounted(() => {
  loadBranchContext();
});

// Expose methods for parent components
__expose({
  loadBranchContext,
  getCurrentBranch: () => currentBranch.value,
  getAccessibleBranches: () => accessibleBranches.value
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentBranch.value)
      ? (_openBlock(), _createBlock(_component_q_chip, {
          key: 0,
          color: getBranchColor(),
          "text-color": "white",
          icon: getBranchIcon(),
          label: formatBranchDisplay(),
          size: "sm",
          class: "q-mr-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(" Current Branch: " + _toDisplayString(currentBranch.value.name) + " ", 1),
                _hoisted_2,
                _createTextVNode("Type: " + _toDisplayString(currentBranch.value.type) + " ", 1),
                _hoisted_3,
                _createTextVNode("Status: " + _toDisplayString(currentBranch.value.status), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["color", "icon", "label"]))
      : _createCommentVNode("", true),
    (accessibleBranchCount.value > 1)
      ? (_openBlock(), _createBlock(_component_q_chip, {
          key: 1,
          color: "grey-6",
          "text-color": "white",
          label: `+${accessibleBranchCount.value - 1} more`,
          size: "sm",
          clickable: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showBranchSelector.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(" You have access to " + _toDisplayString(accessibleBranchCount.value) + " branches total. Click to switch branches. ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true),
    (!currentBranch.value && !loading.value)
      ? (_openBlock(), _createBlock(_component_q_chip, {
          key: 2,
          color: "warning",
          "text-color": "dark",
          icon: "warning",
          label: "No Branch Access",
          size: "sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(" You don't have access to any branches. Contact your administrator. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 3,
          color: "primary",
          size: "1.2em"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: showBranchSelector.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showBranchSelector).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"400px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessibleBranches.value, (branch) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: branch.id,
                        clickable: "",
                        onClick: ($event: any) => (switchToBranch(branch)),
                        class: _normalizeClass({ 'bg-primary text-white': branch.id === currentBranch.value?.id })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: getBranchIcon(branch.type)
                              }, null, 8, ["name"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(branch.name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_label, { caption: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(branch.code) + " | " + _toDisplayString(branch.type), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (branch.id === currentBranch.value?.id)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 0,
                                side: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "check",
                                    color: "white"
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Close",
                  color: "grey"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})